import { Paper, styled } from '@mui/material';

export const StripedContainer = styled(Paper)(({ theme }) => ({
  borderLeft: '5px solid',
  borderColor: theme.palette.primary.main,
  padding: theme.spacing(1),
}));
